import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DeletePopup from "../GardenPopup/DeletePopup"
import UserCreationPopup from "./UserCreationPopup"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { UserCreationDeleteAPI, UserCreationTableDataAPI, UserCreationTableExportDataAPI } from "../../../../Redux/SidebarMasterSlice/UserCreationSlice"
import { RoleNameDataDDL } from "../../../../Components/CommonDDL/RoleNameDataDDL"
import { EmployeeDataDDL } from "../../../../Components/CommonDDL/EmployeeDataDDL"
import { Loading } from "../../../../Helper/Loading"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { useSearchParams } from "react-router-dom"
import { UserCreationExportData } from "./UserCreationDataExportPage"
import { StatusNameDataDDL } from "../../../../Components/CommonDDL/StatusNameDataDDL"
import { ProjectTypeDataDDL } from "../../../../Components/CommonDDL/ProjectTypeDataDDL"
import { DesignationDDL } from "../../../../Components/CommonDDL/DesignationDDL"
import { ProjectNameGridDDL } from "../../../../Components/CommonDDL/ProjectNameGridDDL"
import { EmployeeGridDataDDL } from "../../../../Components/CommonDDL/EmployeeGridDataDDL"


export const UserCreation = () => {

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [WardMasterPopupShow, setWardMasterPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()

    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [UserCreationPopupShow, setUserCreationPopupShow] = useState()
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setUserCreationPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setUserCreationPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setUserCreationPopupShow(false)
    }

    const [Role, setRole] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [DepartmentName, setDepartmentName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [EmployeeDDL, setEmployeeDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Designation, setDesignation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ProjectName, setProjectName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Status, setStatus] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }
    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setRole({
            ...Role,
            ID: 0,
            Label: 'Select...',
        })

        setEmployeeDDL({
            ...EmployeeDDL,
            ID: 0,
            Label: 'Select...',
        })

        setProjectType({
            ...ProjectType,
            ID: 0,
            Label: 'Select...',
        })

        setProjectName({
            ...ProjectName,
            ID: 0,
            Label: 'Select...',
        })

        setDesignation({
            ...Designation,
            ID: 0,
            Label: 'Select...',
        })

        setStatus({
            ...Status,
            ID: 0,
            Label: 'Select...',
        })
    }
    useEffect(() => {
        const data = {
            M_Table_UserID: '0',
            M_RoleID: Role.ID,
            M_ProjectTypeID: RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID,
            M_ProjectID: ProjectName?.ID,
            IsActiveStatusID: Status?.ID,
            M_DesignationID: '0',
            M_EmployeeID: EmployeeDDL.ID,
            // M_UsersID: UserID,
            M_UsersID: 0,
            token: token,
            From: From,
            To: To,
            handleUserCreationExport: handleUserCreationExport
        }
        // if (ProjectType?.ID != 0) {
        //     dispatch(UserCreationTableDataAPI({ data }))
        // }
        if ((RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID) != 0) {
            dispatch(UserCreationTableDataAPI({ data }))
        }
    }, [IsPost, To, IsClear, isSearch, ProjectType?.ID, ProjectName?.ID, Role?.ID, Designation?.ID, EmployeeDDL?.ID, Status?.ID])

    const { tableData, isLoading } = useSelector(state => state.UserCreationTableData)

    const handleUserCreationExport = () => {
        const data = {
            M_Table_UserID: '0',
            M_RoleID: Role.ID,
            M_ProjectTypeID: RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID,
            M_ProjectID: ProjectName?.ID,
            IsActiveStatusID: Status?.ID,
            M_DesignationID: '0',
            M_EmployeeID: EmployeeDDL.ID,
            // M_UsersID: UserID,
            M_UsersID: 0,
            token: token,
            From: '1',
            To: '99999',
        }
        if (ProjectType?.ID != 0) {
            dispatch(UserCreationTableExportDataAPI({ data }))
        }
    }
    // , [IsPost, IsClear, isSearch])

    const { ExportTableData, isExportLoading } = useSelector(state => state.UserCreationTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            M_Table_UserID: item.m_UserID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(UserCreationDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.UserCreationDeleteData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active='usercreation' listActive="masters" />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div className="col-12 d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="m-0 ps-1 py-1">User Creation Master</h5>

                                    <span style={{ fontSize: "16px", color: "gray", fontWeight: "bold" }}>
                                        Total Count: {tableData && tableData.table && tableData.table.length > 0 ? tableData.table[0].totalCount : 0}
                                    </span>

                                    <div className="d-flex align-items-center">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary mx-2" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                // ExportTableData && ExportTableData.table && ExportTableData.table.length
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <span className="mx-2">
                                                    <UserCreationExportData
                                                        ExcelData={ExportTableData}
                                                        name='User Creation Master'
                                                    />
                                                </span>
                                        }
                                        <i className="fa-solid fa-plus btn btn-secondary"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">

                                                {
                                                    RoleID == 1 &&
                                                    <div className="col-12 col-md-4 col-lg-3">
                                                        <ProjectTypeDataDDL
                                                            ProjectType={ProjectType}
                                                            setProjectType={setProjectType}
                                                            IsPost={IsPost}
                                                            M_ProjectTypeID={M_ProjectTypeID}
                                                        />
                                                    </div>
                                                }
                                                <div className="col-12 col-md-4 col-lg-3 ">
                                                    <ProjectNameGridDDL
                                                        M_ProjectTypeID={RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID}
                                                        ProjectName={ProjectName}
                                                        setProjectName={setProjectName}
                                                        APIFlag="UserWiseProject"
                                                        IsPost={IsPost}
                                                    />
                                                </div>

                                                {/* <div className="col-12 col-md-4 col-lg-3">
                                                    <DesignationDDL
                                                        Designation={Designation}
                                                        setDesignation={setDesignation}
                                                        IsPost={IsPost}
                                                        M_RoleID={Role?.ID}
                                                        M_ProjectTypeID={M_ProjectTypeID}
                                                    />
                                                </div> */}

                                                {/* <div className="col-12 col-lg-3 ">
                                            <label for=""><b>Department Name :</b></label>
                                            <Select
                                                // isClearable
                                                // isRtl={isRtl}
                                                isSearchable
                                                maxMenuHeight={150}
                                                value={{ value: DepartmentName.ID, label: DepartmentName.Label }}
                                                onChange={(e) => {
                                                    e ?
                                                        setDepartmentName({ ...DepartmentName, ID: e.value, Label: e.label })
                                                        :
                                                        setDepartmentName({ ...DepartmentName, ID: 0, Label: "Select..." })

                                                }}
                                                options={DepartmentName.DDL}
                                            />
                                        </div> */}

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <EmployeeGridDataDDL
                                                        EmployeeID={EmployeeDDL}
                                                        setEmployeeID={setEmployeeDDL}
                                                        M_ProjectID={ProjectName?.ID}
                                                        M_DesignationID={Designation?.ID}
                                                        IsPost={IsPost}
                                                        M_ProjectTypeID={RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID}
                                                        Flag="ProjectWiseEmployee_User"
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3 ">
                                                    <RoleNameDataDDL
                                                        Role={Role}
                                                        setRole={setRole}
                                                        M_ProjectTypeID={RoleID == 1 ? ProjectType?.ID : M_ProjectTypeID}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <StatusNameDataDDL
                                                        Status={Status}
                                                        setStatus={setStatus}
                                                        // rowData={item}
                                                        rowData={rowData}
                                                        Flag='Insert'
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-2 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            {
                                                                RoleID == 1 &&
                                                                <th>Project Type</th>
                                                            }
                                                            <th>Project Name</th>
                                                            <th>Role</th>
                                                            {/* <th>Department Name</th> */}
                                                            <th>Designation</th>
                                                            <th>Employee Name</th>
                                                            {/* <th>Table User Name</th> */}
                                                            <th>User Name</th>
                                                            <th>Password</th>
                                                            <th>Status</th>
                                                            <th className="action-col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    {
                                                                        RoleID == 1 &&
                                                                        <td>{item.projectType ? item.projectType : '-'}</td>
                                                                    }
                                                                    <td>{item.projectName ? item.projectName : '-'}</td>
                                                                    <td>{item.role ? item.role : '-'}</td>
                                                                    {/* <td></td> */}
                                                                    <td className="min-w-150">{item.designationName ? item.designationName : '-'}</td>
                                                                    <td className="min-w-110">{item.employeeName ? item.employeeName : '-'}</td>
                                                                    {/* <td>{item.tableUserName ? item.tableUserName : '-'}</td> */}
                                                                    <td>{item.userName ? item.userName : '-'}</td>
                                                                    <td>{item.password ? item.password : '-'}</td>
                                                                    <td className="">
                                                                        <span className={`${item.statusName === "Active" ? "badge-style" : "badge-style--orange "}`}
                                                                              style={{     
                                                                                whiteSpace:"no-wrap"  ,                                                                                                                                                                                                                       
                                                                                   width: "80px",
                                                                                       }}>{item.statusName ? item.statusName : '-'}</span>
                                                                        
                                                                        </td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        {/* <UserCreationPopup
                                                                            open={UserCreationPopupShow}
                                                                            item={item}
                                                                            Flag='Update'
                                                                            handleIsPost={handleIsPost}
                                                                        /> */}

                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <></>
                                                        }

                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    UserCreationPopupShow ?
                        <UserCreationPopup
                            open={UserCreationPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </>
    )
}